import { ProductCard } from '@chemist4u/newt-components';
import { toProductCardProps } from '@lib/util/to-product-card-props';
import type { ProductCardVM } from 'types/view-models';

type ProductPreviewProps = {
  card: ProductCardVM;
};

export default function ProductPreview({ card }: ProductPreviewProps) {
  return (
    <div data-testid="product-wrapper" className="h-full w-full">
      <ProductCard {...toProductCardProps(card)} />
    </div>
  );
}
